// Requests
import PostCall from "./CommonApi";

const SaveOrderDetails = (props) => {
    let url = "/v1/ovra/transaction/SaveOrderDetails";
    let requestObject = props;
    return PostCall(url,requestObject);
};

export default SaveOrderDetails;
